@if (envName) {
  <div
    role="status"
    [class]="envName === 'QA'
      ? 'fixed bottom-0 left-0 right-0 z-50 py-1 text-center text-xs font-semibold tracking-widest text-white bg-purple-600'
      : 'fixed bottom-0 left-0 right-0 z-50 py-1 text-center text-xs font-semibold tracking-widest text-white bg-orange-500'">
    AMBIENTE {{ envName }}
  </div>
}

<router-outlet />

<app-toast />
